import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronDown, FiMenu, FiX, FiArrowRight } = FiIcons;

const NAV_ITEMS = [
  {
    label: 'Expertise',
    children: [
      {
        label: 'The Love Code',
        to: '/beziehungsheilung-fuer-frauen',
        desc: 'Beziehungsheilung & emotionale Souveränität',
        tag: 'Beliebt',
      },
      {
        label: 'The Business Code',
        to: '/female-leadership-fuer-frauen',
        desc: 'Feminine Leadership & Soul Business',
        tag: null,
      },
      {
        label: 'Queen Circle',
        to: '/programme',
        desc: 'Exklusive Community & Gruppencoaching',
        tag: 'Neu',
      },
      {
        label: 'Masterclasses',
        to: '/masterclass',
        desc: 'Love Shift & Feminine Business – Kostenlos',
        tag: 'Gratis',
      },
    ],
  },
  {
    label: 'Explore',
    children: [
      {
        label: 'Über Mich',
        to: '/about',
        desc: 'Jennifers Geschichte & Mission',
        tag: null,
      },
      {
        label: 'Boutique',
        to: '/shop',
        desc: 'Kurse, Meditationen & E-Books',
        tag: null,
      },
      {
        label: 'GlücksCall',
        to: '/contact',
        desc: 'Kostenloses 30-Min Erstgespräch',
        tag: 'Kostenlos',
      },
      {
        label: 'Kontakt',
        to: '/contact',
        desc: 'Direkte Anfrage & persönliche Antwort',
        tag: null,
      },
    ],
  },
];

const DropdownMenu = ({ items, isOpen }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, y: 8, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 8, scale: 0.97 }}
        transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
        className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-80 z-50 overflow-hidden"
        style={{
          background: 'rgba(5,5,5,0.97)',
          backdropFilter: 'blur(24px)',
          border: '1px solid rgba(212,175,55,0.15)',
          borderRadius: '3px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.8), 0 0 40px rgba(212,175,55,0.06)',
        }}
      >
        <div className="absolute top-0 left-0 right-0 h-[1px]"
          style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.5), transparent)' }} />
        <div className="p-2">
          {items.map((item, i) => (
            <Link key={i} to={item.to}>
              <motion.div
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.05 }}
                className="group flex items-start gap-4 p-4 rounded-sm transition-all duration-400 relative overflow-hidden"
                style={{ borderRadius: '2px' }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(212,175,55,0.05)';
                  e.currentTarget.style.borderLeft = '2px solid rgba(212,175,55,0.5)';
                  e.currentTarget.style.paddingLeft = '14px';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.borderLeft = '2px solid transparent';
                  e.currentTarget.style.paddingLeft = '16px';
                }}
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-serif text-cream/85 group-hover:text-gold transition-colors duration-400">
                      {item.label}
                    </span>
                    {item.tag && (
                      <span
                        className="text-[9px] uppercase tracking-widest px-2 py-0.5 font-semibold"
                        style={{
                          background: item.tag === 'Gratis' || item.tag === 'Kostenlos'
                            ? 'rgba(114,47,55,0.4)'
                            : item.tag === 'Neu'
                              ? 'rgba(212,175,55,0.15)'
                              : 'rgba(212,175,55,0.12)',
                          color: item.tag === 'Gratis' || item.tag === 'Kostenlos'
                            ? '#c87080'
                            : '#D4AF37',
                          border: `1px solid ${item.tag === 'Gratis' || item.tag === 'Kostenlos'
                            ? 'rgba(114,47,55,0.4)'
                            : 'rgba(212,175,55,0.25)'}`,
                          borderRadius: '2px',
                        }}
                      >
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-cream/40 font-light leading-relaxed group-hover:text-cream/60 transition-colors duration-400">
                    {item.desc}
                  </p>
                </div>
                <SafeIcon
                  icon={FiArrowRight}
                  className="text-cream/20 group-hover:text-gold shrink-0 mt-1 transition-all duration-400 group-hover:translate-x-1"
                  style={{ fontSize: '14px' }}
                />
              </motion.div>
            </Link>
          ))}
        </div>
        <div className="px-4 py-3 border-t border-white/5">
          <p className="text-[10px] text-cream/25 uppercase tracking-widest text-center font-light">
            Coaching Female · Jennifer Gräser
          </p>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

const MobileAccordion = ({ item, isOpen, onToggle, onClose }) => (
  <div className="border-b border-white/5">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-5 px-6 text-left"
    >
      <span className={`text-lg font-serif transition-colors duration-300 ${isOpen ? 'text-gold' : 'text-cream'}`}>
        {item.label}
      </span>
      <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3 }}>
        <SafeIcon icon={FiChevronDown} className="text-gold/60" style={{ fontSize: '18px' }} />
      </motion.div>
    </button>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeInOut' }}
          className="overflow-hidden"
        >
          <div className="pb-4 px-6 space-y-1">
            {item.children.map((child, i) => (
              <Link key={i} to={child.to} onClick={onClose}>
                <motion.div
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.06 }}
                  className="flex items-center justify-between py-3 px-4 group"
                  style={{
                    background: 'rgba(212,175,55,0.03)',
                    border: '1px solid rgba(212,175,55,0.08)',
                    borderRadius: '2px',
                    marginBottom: '4px',
                  }}
                >
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-light text-cream/80 group-hover:text-gold transition-colors">
                        {child.label}
                      </span>
                      {child.tag && (
                        <span className="text-[9px] uppercase tracking-widest px-1.5 py-0.5 text-gold border border-gold/20"
                          style={{ borderRadius: '2px', background: 'rgba(212,175,55,0.08)' }}>
                          {child.tag}
                        </span>
                      )}
                    </div>
                    <p className="text-[11px] text-cream/35 mt-0.5 font-light">{child.desc}</p>
                  </div>
                  <SafeIcon icon={FiArrowRight} className="text-cream/20 group-hover:text-gold transition-colors" style={{ fontSize: '12px' }} />
                </motion.div>
              </Link>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(null);
  const location = useLocation();
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
    setMobileOpen(null);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleMouseEnter = (label) => {
    clearTimeout(timeoutRef.current);
    setActiveDropdown(label);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setActiveDropdown(null), 120);
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-700 ${scrolled ? 'py-3' : 'py-5'}`}
      role="banner"
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 transition-all duration-700 ${scrolled
          ? 'bg-dark/92 backdrop-blur-2xl border-b border-white/5'
          : 'bg-dark/50 backdrop-blur-md'
          }`}
      />

      {/* Gold top line */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 2, delay: 0.5 }}
        className="absolute top-0 left-0 right-0 h-[1px] origin-left"
        style={{ background: 'linear-gradient(to right, #D4AF37, rgba(212,175,55,0.3), transparent)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 flex items-center justify-between gap-8">

        {/* Logo */}
        <Link
          to="/"
          aria-label="Coaching Female – Zurück zur Startseite"
          className="flex items-center gap-3 shrink-0 group"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <span
              className="text-2xl font-serif text-gold"
              style={{ textShadow: '0 0 20px rgba(212,175,55,0.6)' }}
            >
              CF.
            </span>
          </motion.div>
          <div className="hidden sm:block">
            <span className="text-xs uppercase tracking-[0.3em] text-cream/70 group-hover:text-cream transition-colors duration-500 font-light block">
              Coaching Female
            </span>
            <span className="text-[9px] uppercase tracking-widest text-gold/50 font-light">
              Jennifer Gräser
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-1" role="navigation" aria-label="Hauptnavigation">
          {NAV_ITEMS.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => handleMouseEnter(item.label)}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className={`flex items-center gap-1.5 px-4 py-2 text-xs uppercase tracking-widest transition-all duration-400 rounded-sm group ${activeDropdown === item.label ? 'text-gold' : 'text-cream/65 hover:text-cream'
                  }`}
                aria-expanded={activeDropdown === item.label}
                aria-haspopup="true"
              >
                {item.label}
                <motion.div
                  animate={{ rotate: activeDropdown === item.label ? 180 : 0 }}
                  transition={{ duration: 0.25 }}
                >
                  <SafeIcon
                    icon={FiChevronDown}
                    className={`transition-colors duration-400 ${activeDropdown === item.label ? 'text-gold' : 'text-cream/30'}`}
                    style={{ fontSize: '12px' }}
                  />
                </motion.div>
                <span
                  className={`absolute bottom-0 left-4 right-4 h-[1px] transition-all duration-400 ${activeDropdown === item.label ? 'opacity-100' : 'opacity-0'}`}
                  style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.6), transparent)' }}
                />
              </button>
              <DropdownMenu items={item.children} isOpen={activeDropdown === item.label} />
            </div>
          ))}

          {/* Direct Links */}
          <Link
            to="/love-shift-masterclass"
            className="px-4 py-2 text-xs uppercase tracking-widest text-cream/65 hover:text-cream transition-colors duration-400 relative group"
          >
            Love Shift
            <span className="absolute bottom-0 left-4 right-4 h-[1px] w-0 group-hover:w-[calc(100%-2rem)] transition-all duration-500 origin-left"
              style={{ background: 'rgba(212,175,55,0.5)' }} />
          </Link>
        </nav>

        {/* CTA Buttons */}
        <div className="hidden lg:flex items-center gap-3 shrink-0">
          <Link to="/masterclass">
            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="px-5 py-2.5 text-xs uppercase tracking-widest text-wine-light border border-wine/40 hover:border-wine-light hover:bg-wine/10 transition-all duration-500 font-semibold"
              style={{ borderRadius: '2px' }}
            >
              Masterclass Gratis
            </motion.div>
          </Link>
          <Link to="/contact">
            <motion.div
              whileHover={{
                scale: 1.04,
                boxShadow: '0 0 30px rgba(212,175,55,0.5), 0 0 60px rgba(212,175,55,0.2)',
              }}
              whileTap={{ scale: 0.97 }}
              className="px-6 py-2.5 bg-gold-gradient text-dark font-bold uppercase tracking-widest text-xs relative overflow-hidden group"
              style={{
                boxShadow: '0 0 15px rgba(212,175,55,0.3)',
                borderRadius: '2px',
              }}
            >
              <span className="relative z-10">✦ GlücksCall</span>
              <div className="absolute inset-0 bg-white/15 translate-x-[-110%] skew-x-[-20deg] group-hover:translate-x-[200%] transition-transform duration-700 ease-in-out" />
            </motion.div>
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <motion.button
          className="lg:hidden relative z-10 w-10 h-10 flex items-center justify-center text-cream"
          onClick={() => setIsOpen(!isOpen)}
          whileTap={{ scale: 0.9 }}
          aria-label={isOpen ? 'Menü schließen' : 'Menü öffnen'}
          aria-expanded={isOpen}
        >
          <AnimatePresence mode="wait" initial={false}>
            {isOpen ? (
              <motion.div key="close"
                initial={{ rotate: -90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: 90, opacity: 0 }}
                transition={{ duration: 0.2 }}>
                <SafeIcon icon={FiX} style={{ fontSize: '22px' }} />
              </motion.div>
            ) : (
              <motion.div key="open"
                initial={{ rotate: 90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: -90, opacity: 0 }}
                transition={{ duration: 0.2 }}>
                <SafeIcon icon={FiMenu} style={{ fontSize: '22px' }} />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden"
            style={{
              background: 'rgba(3,3,3,0.98)',
              backdropFilter: 'blur(24px)',
              borderTop: '1px solid rgba(212,175,55,0.1)',
            }}
          >
            <div className="max-h-[80vh] overflow-y-auto">
              {/* Accordions */}
              {NAV_ITEMS.map((item, i) => (
                <MobileAccordion
                  key={i}
                  item={item}
                  isOpen={mobileOpen === item.label}
                  onToggle={() => setMobileOpen(mobileOpen === item.label ? null : item.label)}
                  onClose={() => setIsOpen(false)}
                />
              ))}

              {/* Direct link */}
              <div className="border-b border-white/5">
                <Link
                  to="/love-shift-masterclass"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center justify-between py-5 px-6 group"
                >
                  <span className="text-lg font-serif text-cream group-hover:text-gold transition-colors">
                    Love Shift
                  </span>
                  <SafeIcon icon={FiArrowRight} className="text-cream/20 group-hover:text-gold transition-colors" />
                </Link>
              </div>

              {/* Mobile CTAs */}
              <div className="p-6 space-y-4">
                <Link to="/masterclass" onClick={() => setIsOpen(false)}>
                  <motion.div
                    whileTap={{ scale: 0.97 }}
                    className="w-full py-4 text-center text-sm uppercase tracking-widest text-wine-light border border-wine/40 font-semibold"
                    style={{ borderRadius: '2px' }}
                  >
                    ✦ Masterclass Gratis anmelden
                  </motion.div>
                </Link>
                <Link to="/contact" onClick={() => setIsOpen(false)}>
                  <motion.div
                    whileTap={{ scale: 0.97 }}
                    className="w-full py-4 text-center text-sm uppercase tracking-widest text-dark font-bold bg-gold-gradient relative overflow-hidden group"
                    style={{
                      boxShadow: '0 0 25px rgba(212,175,55,0.4)',
                      borderRadius: '2px',
                    }}
                  >
                    <span className="relative z-10">✦ GlücksCall buchen</span>
                    <div className="absolute inset-0 bg-white/15 translate-x-[-110%] skew-x-[-20deg] group-hover:translate-x-[200%] transition-transform duration-700" />
                  </motion.div>
                </Link>
              </div>

              {/* Mobile footer */}
              <div className="px-6 pb-6 pt-2 flex items-center justify-between border-t border-white/5">
                <p className="text-[10px] text-cream/25 uppercase tracking-widest">
                  © 2026 Coaching Female
                </p>
                <div className="flex gap-3">
                  {[
                    { label: 'Impressum', to: '/impressum' },
                    { label: 'Datenschutz', to: '/datenschutz' },
                  ].map(l => (
                    <Link key={l.label} to={l.to} onClick={() => setIsOpen(false)}
                      className="text-[10px] text-cream/25 hover:text-gold transition-colors uppercase tracking-widest">
                      {l.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;